import "./Home.module.css";
import NavigationHeader from "@/reusable_sections/Header";
import LArtDeBatirEtDeRenover from "./sections/LArtDeBatirEtDeRenover";
import VisionFondations from "./sections/VisionFondations";
import Layout from "./sections/Layout";
import NosPolesDexpertise from "./sections/NosPolesDexpertise";
import PerformanceEnergetique from "./sections/PerformanceEnergetique";
import EngagementQualite from "./sections/EngagementQualite";
import LancezVotreProjet from "./sections/LancezVotreProjet";
import Developments from "./sections/Developments";
import PiedDePage from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <NavigationHeader />
      <LArtDeBatirEtDeRenover />
      <VisionFondations />
      <Layout />
      <NosPolesDexpertise />
      <Developments />
      <PerformanceEnergetique />
      <EngagementQualite />
      <LancezVotreProjet />
      <PiedDePage />
    </div>;
}